/* ENISSATI · Collection Grid — vanilla JS
   - AJAX add-to-cart nos cards (POST /cart/add.js)
   - Auto-submit do filter form ao mudar checkbox / sort
   - Fechar dropdown ao clicar fora */
(function () {
  'use strict';

  function init(section) {
    var form = section.querySelector('#ss-cg-filter-form');

    // Auto-submit ao mudar filtros ou sort — preserva URL params do Shopify
    if (form) {
      form.addEventListener('change', function (ev) {
        // Ignora cliques que não sejam em input/select
        if (ev.target.matches('input, select')) {
          form.requestSubmit ? form.requestSubmit() : form.submit();
        }
      });
      // Submit também ao perder foco em inputs numéricos (price range)
      form.querySelectorAll('input[type="number"]').forEach(function (input) {
        input.addEventListener('blur', function () {
          form.requestSubmit ? form.requestSubmit() : form.submit();
        });
      });
    }

    // Fechar <details> filter ao clicar fora
    document.addEventListener('click', function (ev) {
      section.querySelectorAll('.ss-cg__filter[open]').forEach(function (d) {
        if (!d.contains(ev.target)) d.removeAttribute('open');
      });
    });

    // AJAX add-to-cart
    section.querySelectorAll('[data-add-to-cart]').forEach(function (btn) {
      btn.addEventListener('click', function (ev) {
        ev.preventDefault();
        var variantId = btn.getAttribute('data-variant-id');
        var productTitle = btn.getAttribute('data-product-title') || 'Produit';
        if (!variantId) return;

        btn.classList.add('is-loading');
        btn.disabled = true;
        var originalText = btn.querySelector('.ss-cg__card-add-text');
        var originalLabel = originalText ? originalText.textContent : '';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Add to cart failed');
            return res.json();
          })
          .then(function () {
            btn.classList.remove('is-loading');
            btn.classList.add('is-success');
            if (originalText) originalText.textContent = '✓';

            // Atualiza badge + drawer (contrato Krunkers: documentElement + detail.cart)
            fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
              document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
            }).catch(function () {});

            // GA4 tracking opcional
            if (typeof gtag === 'function') {
              gtag('event', 'add_to_cart', { variant_id: variantId, source: 'collection_card' });
            }

            setTimeout(function () {
              btn.classList.remove('is-success');
              btn.disabled = false;
              if (originalText) originalText.textContent = originalLabel;
            }, 2200);
          })
          .catch(function (err) {
            console.warn('[ss-cg] add-to-cart error', err);
            btn.classList.remove('is-loading');
            btn.classList.add('is-error');
            if (originalText) originalText.textContent = 'Erreur';
            setTimeout(function () {
              btn.classList.remove('is-error');
              btn.disabled = false;
              if (originalText) originalText.textContent = originalLabel;
            }, 2200);
          });
      });
    });
  }

  function boot() { document.querySelectorAll('[data-collection-grid]').forEach(init); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    if (ev.target && ev.target.querySelector) {
      ev.target.querySelectorAll('[data-collection-grid]').forEach(init);
    }
  });
})();
